import { ReactNode } from 'react';
import styles from './Button.module.scss';

interface ButtonProps {
  label?: string;
  children?: ReactNode;
  className?: string;
  outline?: boolean;
  small?: boolean;
  block?: boolean;
  plain?: boolean;
  disabled?: boolean;
  delete?: boolean;
  image?: string;
  variant?: 'primary' | 'secondary' | 'plain' | 'outline' | 'delete' | 'cancel';
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  hidden?: boolean;
}

export const Button: React.FC<ButtonProps> = (props) => {
  const {
    label,
    children,
    className,
    outline,
    small,
    block,
    plain,
    disabled,
    hidden,
    image,
    variant,
    onClick,
    ...rest
  } = props;

  const buttonClasses = [
    styles.button,
    className,
    outline && styles['button--outline'],
    small && styles['button--small'],
    block && styles['button--block'],
    plain && styles['button--plain'],
    disabled && styles['button--disabled'],
    hidden && styles['button--hidden'],
    variant && styles[`button--${variant}`],
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      onClick={onClick}
      className={buttonClasses}
      {...rest}
    >
      {image && (
        <img
          src={image}
          alt="Button Image"
        />
      )}
      {label || children}
    </button>
  );
};
